export default angular.module('menu', [])
	.directive("menu", function() {
		return {
			templateUrl: 'menu/menuDirective.tpl.html',
			restrict: "E",
			scope: {},
			controller: 'MenuController',
			controllerAs: 'ctrl',
			bindToController: {
				data: '='
			}
		};
	}).controller('MenuController', function MenuController() {
	}).name;



// WEBPACK FOOTER //
// build/menu/menuDirective.js